export default {
    section: 'Other Information',
    name: 'entity-formation-other',
    questionWidth: 4,
    items: [
        {
            type: 'radio-list',
            text: 'Calendar year accounting?',
            name: 'entity-formation-year-acounting',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            },
            subItems: [
                {
                    type: 'text-field',
                    text: 'Please indicate your year-end',
                    name: 'entity-formation-year-accounting-other',
                    width: 3,
                    props: {
                        label: 'Year-End'
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'entity-formation-year-acounting',
                                value: 'no'
                            }
                        ]
                    }
                }
            ]
        },
        {
            type: 'radio-list',
            text: 'Cash or accrual accounting?',
            name: 'entity-formation-cash-accrual',
            props: {
                items: [
                    {
                        text: 'Cash',
                        value: 'cash'
                    },
                    {
                        text: 'Accrual',
                        value: 'accrual'
                    }
                ]
            }
        },
        {
            type: 'radio-list',
            text: 'Is this a merger of business, a purchase of an existing business, or a conversion from one type of business/entity to another?',
            name: 'entity-formation-prior-business',
            width: 3,
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            }
        },
        {
            type: 'textarea',
            text: 'Please explain and give the name of prior business',
            name: 'entity-formation-prior-business-description',
            props: {},
            dependencies: {
                items: [
                    {
                        name: 'entity-formation-prior-business',
                        value: 'yes'
                    }
                ]
            }
        },
        {
            type: 'radio-list',
            text: 'Have you previously applied for a license with the state?',
            name: 'entity-formation-previous-application',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            }
        },
        {
            type: 'radio-list',
            text: 'Are you a home-based business?',
            name: 'entity-formation-home-based',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            }
        },
        {
            type: 'radio-list',
            text: 'Do you have employees?',
            name: 'entity-formation-has-employees',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            },
            subItems: [
                {
                    type: 'text-field',
                    text: 'How many employees?',
                    name: 'entity-formation-employee-count',
                    width: 3,
                    props: {
                        label: 'Employee Count',
                        format: 'number'
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'entity-formation-has-employees',
                                value: 'yes'
                            }
                        ]
                    }
                }
            ]
        },
        {
            type: 'datepicker',
            text: 'Estimated date when entity will start paying wages',
            name: 'entity-formation-estimated-start-wages',
            width: 3,
            props: {
                label: 'Estimated Date'
            }
        },
        {
            type: 'textarea',
            text: 'Please provide a description of particular topics pertaining to this service that you wish to discuss during the initial intake call and/or subsequent calls',
            name: 'entity-formation-other-description',
            props: {}
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/entity-new/valuation-data/other-information.js